import { faAward, faBuilding, faCertificate, faUniversity } from '@fortawesome/free-solid-svg-icons';
import './styles/certificate-info-style.css';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateColors } from '../../../../../utils/colorUtilsClientInfo';
import CertificationIcon from '../../../../../assets/images/ic_certificates.png';

const CertificationInfoPanel = ({ colorSeed, certificate }) => {
  const colours = generateColors(colorSeed);
  return (
    <Row className="certificateInfoContainer mt-1 d-flex ">
      <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center ">
        <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
          <img src={CertificationIcon} alt="Certifications" className="profile-work-experience-nav-icon" />
        </span>
      </Col>
      <Col xs={10} sm={10} lg={11}>
        <Row>
          <Col xs={12}>
            <span className="title pt-1">{_.get(certificate, 'title')}</span>
            {_.get(certificate, 'universityOrCollege') && (
              <span className="sub-title"> from {_.get(certificate, 'universityOrCollege')}</span>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <span className="sub-title1">
              {' '}
              {_.get(certificate, 'startDate')} - {_.get(certificate, 'endDate')}
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CertificationInfoPanel;
